var exports = {
  "Z": "xe7b6e3d6--5ca9bf--layout",
};

module.exports = exports;
